import { createContext } from 'react';

const NodeConfigurationContext = createContext({
  showDetails: false,
  setShowDetails: (show?: boolean) => {},
});
export default NodeConfigurationContext;
